export default __webpack_public_path__ + "static/media/kitchen3-afterG-1920w.1f923adf.png";